/**
 * `billing.contact.email` reads as "Billing contact email".
 *
 * The paths are dotted and camelCase, and a screen that showed them raw would
 * be showing its wire format to somebody administering a company.
 *
 * Shared rather than private to the composable, because the object groups need
 * the same conversion for the leaf beneath a group — `billing.legalName` under
 * a "Billing facts" header is "Legal name", not "Billing legal name".
 */
export function labelFor(path) {
    // Two boundaries, not one. Splitting only where a lowercase letter meets an
    // uppercase one left `addressLine1` reading as "Address line1" wherever a
    // numbered field appeared.
    const words = path
        .split('.')
        .flatMap((segment) => segment
            .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
            .replace(/([a-zA-Z])([0-9])/g, '$1 $2')
            .split(' '))
        .filter((word) => word !== '')
    if (words.length === 0) {
        return path
    }
    const [first, ...rest] = words
    return [first.charAt(0).toUpperCase() + first.slice(1), ...rest.map((w) => w.toLowerCase())]
        .map((word) => SPELLED[word.toLowerCase()] ?? word)
        .join(' ')
}

// Words a sentence-case label still spells their own way: "Stripe subscription
// ID", not "Stripe subscription id".
const SPELLED = {
    id: 'ID',
    stripe: 'Stripe'
}
